import buildItemComponent from "../../common/item-component-hoc"

import ClusterViewItemContainer from "./view/ClusterViewItemContainer"
import ClusterViewFormActionButtonsWidgetContainer from "./view/ClusterViewFormActionButtonsWidgetContainer"
import ClusterEditItemContainer from "./edit/ClusterEditItemContainer"
import ClusterEditFormActionButtonsWidgetContainer from "./edit/ClusterEditFormActionButtonsWidgetContainer"

const Cluster = buildItemComponent("clusters", {
    view: [
        ClusterViewFormActionButtonsWidgetContainer,
        ClusterViewItemContainer
    ],
    edit: [
        ClusterEditFormActionButtonsWidgetContainer,
        ClusterEditItemContainer
    ]
})

export default Cluster
